module.exports = __webpack_public_path__ + "ab656ecedcbba0a7dfd937ac398061f9.png";